import { Ring } from '@uiball/loaders'
import InfoBlock from 'components/UI/Blocks/InfoBlock'
import Typography from 'components/UI/Typography'
import Heading from 'components/UI/Typography/Heading'
import { useTranslation } from 'react-i18next'
import tw from 'twin.macro'

const BiometryProcessing = () => {
  const { t } = useTranslation()

  return (
    <InfoBlock twStyle={tw`flex flex-col items-center h-full text-center`}>
      <Heading variant='subtitle'>{t('flow-please-wait')}!</Heading>
      <Typography variant='subbody' twStyle={tw`text-grey-dark mt-2 mb-16`}>
        {t('flow-biometry-process')}
      </Typography>
      <Ring color='var(--primary-color)' size={64} />
    </InfoBlock>
  )
}

export default BiometryProcessing
